import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchEmissionAlerts } from "../thunk/MapSliceThunk";

const initialData: any = [];

const EmissionAlertSlice: Slice<any, {}, "EmissionAlertSlice"> = createSlice({
    name: "EmissionAlertSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchEmissionAlerts.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchEmissionAlerts.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchEmissionAlerts.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default EmissionAlertSlice